// extracted by mini-css-extract-plugin
export default {"jobDetails":"MarketplaceStyles_jobDetails__xjtUE","jobDetails__list":"MarketplaceStyles_jobDetails__list__Skz6-"};